import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[#F8F8F6]" data-id="element-117">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-118">
        {/* Text Content */}
        <div className="z-10 order-2 lg:order-1" data-id="element-119">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-[#0C0C0C] leading-[1.1] mb-6 tracking-tight" data-id="element-120">
            <span className="text-[#00316B]" data-id="element-121">
              Designing Digital Experiences That Drive Real{' '}
            </span>
            <span className="text-[#FF6600]" data-id="element-122">Business Growth</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: 'easeOut'
        }} className="text-lg md:text-xl text-gray-600 mb-8 max-w-lg leading-relaxed" data-id="element-123">
            We help businesses and brands design, build, and scale modern
            digital solutions — from strategy and design to development and
            growth.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-124">
            <Button size="lg" className="bg-[#FF6600] text-white hover:bg-[#CC5200] px-8" data-id="element-125">
              Start a Project
            </Button>
            <Button variant="outline" size="lg" className="border-gray-300 hover:bg-white" data-id="element-126">
              View Our Work
            </Button>
          </motion.div>
        </div>

        {/* Visual Content */}
        <div className="relative h-[400px] md:h-[600px] w-full flex items-center justify-center order-1 lg:order-2" data-id="element-127">
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.5
        }} className="relative w-full h-full" data-id="element-128">
            {/* Abstract Composition */}
            <svg viewBox="0 0 600 600" className="w-full h-full absolute inset-0 text-[#2D2D6B]/10" data-id="element-129">
              <motion.circle cx="300" cy="300" r="150" fill="currentColor" initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              duration: 1.2,
              ease: 'easeOut',
              delay: 0.6
            }} data-id="element-130" />
              <motion.rect x="100" y="100" width="200" height="200" fill="#E5E7EB" className="opacity-50" initial={{
              x: -50,
              opacity: 0
            }} animate={{
              x: 100,
              opacity: 0.5
            }} transition={{
              duration: 1,
              delay: 0.8
            }} data-id="element-131" />
              <motion.rect x="350" y="250" width="150" height="250" fill="#00316B" className="opacity-20" initial={{
              y: 50,
              opacity: 0
            }} animate={{
              y: 250,
              opacity: 0.2
            }} transition={{
              duration: 1,
              delay: 1
            }} data-id="element-132" />
              <motion.circle cx="450" cy="150" r="30" fill="#0C0C0C" className="opacity-10" initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              duration: 0.8,
              delay: 1.2
            }} data-id="element-133" />
              {/* Decorative Lines */}
              <motion.line x1="50" y1="500" x2="550" y2="500" stroke="#0C0C0C" strokeWidth="1" className="opacity-10" initial={{
              pathLength: 0
            }} animate={{
              pathLength: 1
            }} transition={{
              duration: 1.5,
              delay: 0.5
            }} data-id="element-134" />
              <motion.line x1="500" y1="50" x2="500" y2="550" stroke="#0C0C0C" strokeWidth="1" className="opacity-10" initial={{
              pathLength: 0
            }} animate={{
              pathLength: 1
            }} transition={{
              duration: 1.5,
              delay: 0.7
            }} data-id="element-135" />
            </svg>

            {/* Floating UI Card Mockup */}
            <motion.div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-white/50 w-64 md:w-80" initial={{
            y: 50,
            opacity: 0
          }} animate={{
            y: '-50%',
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 1.4
          }} data-id="element-136">
              <div className="flex items-center gap-3 mb-4" data-id="element-137">
                <div className="w-10 h-10 rounded-full bg-gray-100" data-id="element-138"></div>
                <div className="space-y-2" data-id="element-139">
                  <div className="h-2 w-24 bg-gray-200 rounded" data-id="element-140"></div>
                  <div className="h-2 w-16 bg-gray-100 rounded" data-id="element-141"></div>
                </div>
              </div>
              <div className="h-24 bg-gray-50 rounded-lg mb-4" data-id="element-142"></div>
              <div className="flex justify-between items-center" data-id="element-143">
                <div className="h-8 w-20 bg-[#FF6600] rounded-md" data-id="element-144"></div>
                <div className="h-8 w-8 rounded-full border border-gray-200" data-id="element-145"></div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}